'use client';

import RialWhiteIso from '@/assets/icon/RialWhiteIso';
import chileglobalangels from '@/assets/stakeholders/ChileGlobalAngels.webp';
import corfo from '@/assets/stakeholders/Corfo.webp';
import drivenspeed from '@/assets/stakeholders/DrivenSpeed.webp';
import guerreroolivos from '@/assets/stakeholders/GuerreroOlivos.webp';
import startupchile from '@/assets/stakeholders/StartupChile.webp';
import { ArrowRightIcon } from '@phosphor-icons/react';
import ImageWithLoader from '../common/images/ImageWithLoader';
import { Button } from '../ui/button';

export default function WelcomeFooter() {
  return (
    <div className="w-full min-w-96 px-8 pt-20 pb-8 bg-gradient-to-br from-[#233B57] to-[#4C80BD] flex flex-col justify-start items-center gap-10">
      <div className="w-36 h-20 relative overflow-hidden">
        <RialWhiteIso />
      </div>

      <div className="w-full flex flex-col justify-start items-center gap-8 max-w-6xl">
        <div className="self-stretch text-center justify-center text-white text-4xl font-semibold leading-10">
          Transforma tu próxima campaña, agenda una demo con RIAL
        </div>
        <div className="self-stretch text-center justify-start text-white text-xl font-normal leading-loose">
          Descubre cómo generar imágenes hiperrealistas de moda sin estudios, modelos ni
          postproducción. Más rápido, más económico, más escalable.
        </div>
        <Button
          variant="clear"
          className="bg-white"
          rightIcon={<ArrowRightIcon />}
          onClick={() => window.open('https://calendly.com/rial-ai/30min', '_blank')}
        >
          Agendar una demo
        </Button>
      </div>

      <div className="self-stretch px-8 flex flex-col justify-center items-center gap-6">
        <div className="flex-1 md:text-end text-center justify-end text-white text-sm font-normal leading-tight w-full">
          @2025 RIAL, todos los derechos reservados.
        </div>
        <div className="flex flex-wrap self-stretch h-px bg-gray-200 w-full" />
        <div className="flex justify-center items-center gap-12 w-full flex-col md:flex-row">
          <p className="text-white text-sm font-normal leading-tight">Con el apoyo de:</p>
          <div className="flex flex-col md:flex-row justify-start items-center gap-12 flex-wrap">
            <ImageWithLoader
              src={corfo}
              alt="logo"
              width={100}
              height={100}
              imageclassname="h-full w-full"
              className="w-36 flex items-center justify-center"
            />
            <ImageWithLoader
              src={startupchile}
              alt="logo"
              width={100}
              height={100}
              className="w-36 flex items-center justify-center"
              imageclassname="h-full w-full flex items-center justify-center"
            />
            <ImageWithLoader
              src={chileglobalangels}
              alt="logo"
              width={100}
              height={100}
              className="w-36 flex items-center justify-center"
              imageclassname="h-full w-full flex items-center justify-center"
            />
            <ImageWithLoader
              src={guerreroolivos}
              alt="logo"
              width={100}
              height={100}
              className="w-36 flex items-center justify-center"
              imageclassname="h-full w-full flex items-center justify-center"
            />
            <ImageWithLoader
              src={drivenspeed}
              alt="logo"
              width={100}
              height={100}
              className="w-36 flex items-center justify-center"
              imageclassname="h-full w-full flex items-center justify-center"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
